import AppConstants from '../appConstants';
import { Validator } from 'vee-validate';
import pt_BR from "vee-validate/dist/locale/pt_BR";
import en from "vee-validate/dist/locale/en";
import es from "vee-validate/dist/locale/es";
import pt_PT from "vee-validate/dist/locale/pt_PT";
import Vue from 'vue';

const ENUM_LOCALE = {
  "PtBr": 1, "EnEu": 2, "EsEs": 3, "EsAr": 4, "PtPt": 5
};

export function getLocaleCode(locale) {
  if (locale === "PtBr" || locale === "EnEu" || locale === "EsEs" || locale === "EsAr" || locale === "PtPt") {
    return ENUM_LOCALE[locale];
  }
  return ENUM_LOCALE.PtBr;
}

export function getCodeLang(code) {
  switch (Number(code)) {
    case 1:
      return "PtBr";
    case 2:
      return "EnEu";
    case 3:
      return "EsEs";
    case 4:
      return "EsAr";
    case 5:
      return "PtPt";
    default:
      return "PtBr";
  }
}

export function getCodeLangFromBrowser() {
  // const lang = navigator.language;
  if (navigator.language === "pt-BR" || navigator.language === "pt") {
    return "PtBr"
  } else if (navigator.language === "es-AR") {
    return "EsAr";
  } else if (navigator.language === "es") {
    return "EsEs";
  } else if (navigator.language === "pt-PT") {
    return "PtPt";
  }

  return "EnEu";
}

export function getVoiceLang(country) {
  if (!country) {
    return "pt-BR";
  }

  switch (Number(country)) {
    case 1:
      return "pt-BR";
    case 2:
      return "en-US";
    case 3:
      return "es-ES";
    case 4:
      return "es-ES";
    case 5:
      return "pt-PT";
    default:
      return "pt-BR";
  }
}

export function getMomentLocale(locale) {
  switch (locale) {
    case 'PtBr':
      return 'pt';
    case 'EnEu':
      return 'en';
    case 'EsEs':
      return 'es';
    case 'EsAr':
      return 'es';
    case 'PtPt':
      return 'pt'
  }
}

export function getWdmaLocale(locale) {
  switch (locale) {
    case 'PtBr':
      return 'pt-br';
    case 'EnEu':
      return 'en-us';
    case 'EsEs':
      return 'es-es';
    case 'EsAr':
      return 'es-ar';
    case 'PtPt':
      return 'pt-pt';
    default:
      return 'pt-br';
  }
}

export function getWhatsitDocumentURLByLocale(locale) {
  switch (locale) {
    case 'PtBr':
      return `${Vue.prototype.$config.base_url}/${AppConstants.URL_DOCUMENT_WHATSIT_BR}`
    case 'EnEu':
      return `${Vue.prototype.$config.base_url}/${AppConstants.URL_DOCUMENT_WHATSIT_EN}`
    case 'EsEs':
      return `${Vue.prototype.$config.base_url}/${AppConstants.URL_DOCUMENT_WHATSIT_ES}`
    case 'EsAr':
      return `${Vue.prototype.$config.base_url}/${AppConstants.URL_DOCUMENT_WHATSIT_ES}`
    case 'PtPt':
      return `${Vue.prototype.$config.base_url}/${AppConstants.URL_DOCUMENT_WHATSIT_BR}`
    default:
      return `${Vue.prototype.$config.base_url}/${AppConstants.URL_DOCUMENT_WHATSIT_EN}`
  }
}

export function updateVeeValidateLocale(locale) {
  console.log('[updateVeeValidateLocale]');
  switch (locale) {
    case 'PtBr':
      Validator.localize("pt_BR", pt_BR);
      break;
    case 'EnEu':
      Validator.localize("en", en);
      break;
    case 'EsEs':
      Validator.localize("es", es);
      break;
    case 'EsAr':
      Validator.localize("pt_BR", es);
      break;
    case 'PtPt':
      Validator.localize("pt_PT", pt_PT);
      break;
    default:
      Validator.localize("pt_BR", pt_BR);
      break;
  }
}
